module.exports = (__webpack_require__("bricks/next-builder:b9y2"))("yXPU");